export const STAFF_ROLES = [
  "fondateur",
  "co_fondateur",
  "superadmin",
  "admin",
  "moderateur_plus",
  "moderateur",
  "moderateur_essai",
];

export const ADMIN_ROLES = ["fondateur", "co_fondateur", "superadmin", "admin"];
export const SHOP_ROLES = ["fondateur", "co_fondateur"];

export const isStaff = (user) => !!user && STAFF_ROLES.includes(user.role);
export const isAdminRole = (user) => !!user && ADMIN_ROLES.includes(user.role);
export const isShopAdmin = (user) => !!user && SHOP_ROLES.includes(user.role);
